import type { AsyncBelongsTo, AsyncHasMany } from '@ember-data/model';
import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import formatPhone from 'garaje/helpers/format-phone';

import type VisitCompositeModel from './visit-composite';

export default class VisitorProfileModel extends Model {
  @hasMany('visit-composite', { async: true, inverse: 'visitorProfile' })
  declare visits: AsyncHasMany<VisitCompositeModel>;

  @belongsTo('visit-composite', { async: true, inverse: null })
  declare relevantVisit: AsyncBelongsTo<VisitCompositeModel>;

  // use if relevantVisit is pre-loaded
  get relevantVisitSync(): VisitCompositeModel | null {
    return this.relevantVisit.content || null;
  }

  @attr('string') declare displayName: string;
  @attr('string') declare primaryEmail: string | null;
  @attr('string') declare primaryPhoneNumber: string | null;
  @attr('string') declare photoUrl: string | null;

  @attr() declare identifiers: {
    emails: string[];
    aliases: string[];
    'phone-numbers': string[];
  } | null;

  get formattedPhoneNumber(): string {
    return formatPhone(this.primaryPhoneNumber);
  }
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'visitor-profile': VisitorProfileModel;
  }
}
